import React, { useEffect, useRef, useState } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useWarehouseModel } from "../../warehouseModel";
import { ISCMWarehouseDetail } from "../../warehouseTypes";
import { getFormValidatorErrText } from "@/utils/utils";
import { useDictModel } from "../../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { ShelfTable } from "./ShelfTable";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function WarehouseDatalis() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { editFormVal, updateEditFormVal, editWarehouse, getWarehouseOne, shelfLoadData } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!editFormVal.id) {
            getWarehouseOne(detailsInfo.id)

        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav("13-3-2") && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "13-3");
    }

    //仓库修改提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            let typeName = getTreeNodeName(res.typeCode)
            editWarehouse({ ...res, id: detailsInfo.id, typeName } as ISCMWarehouseDetail).then(res => {
                res && onClose()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时缓存
    const onChange = (changedValues: any) => {
        updateEditFormVal(changedValues);
    }
    const reset = () => {
        getWarehouseOne(detailsInfo.id)
        shelfLoadData(detailsInfo.id, { pageSize: 15, pageNum: 1 });
        // message.success("重置成功")
        message.success(Locale['Successfully refreshed'])
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onSubmit}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => reset()}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "13-3")}
        >{Locale["Back"]}</Button>
    </>;

    const baseFormItem: IYhFormItemsBox = {
        // title: "仓库详情",
        title: Locale["Warehouse Details"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        action: action,
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "仓库编码",
                fieldLabel:Locale["Warehouse Code"],
                fieldName: "code",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "仓库名称",
                fieldLabel:Locale["Warehouse Name"],
                fieldName: "name",
                rules: [{ required: true, message: "请输入仓库名称" }]
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "仓库类别",
                fieldLabel:Locale["Warehouse Type"],
                fieldName: "typeCode",
                options: getSelectedDictOne(DictCodeEnmu.CK_TYPE),
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel:Locale["Contact"],
                fieldName: "contact"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel:Locale["Contact Number"],
                fieldName: "phone"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系地址",
                fieldLabel:Locale["Address"],
                fieldName: "address"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel:Locale["Note"],
                fieldName: "note"
            }
        ]
    };

    const warehouseFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: editFormVal,
        onChange,
        boxs: [baseFormItem]
    }

    return (
        <>
            <YhPageHeader title={Locale["Warehouse Settings"]} />
            <YhFormBox {...warehouseFromConfig} />
            <ShelfTable {...detailsInfo} />
            {/* {editFormVal.id? <WarehouseDetailsTabs /> : null} */}
        </>
    )
}